/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum UserAccessContextOrigin {
    Self = 'Self',
    OtherContext = 'OtherContext'
}


export function instanceOfUserAccessContextOrigin(value: any): boolean {
    for (const key in UserAccessContextOrigin) {
        if (Object.prototype.hasOwnProperty.call(UserAccessContextOrigin, key)) {
            if (UserAccessContextOrigin[key as keyof typeof UserAccessContextOrigin] === value) {
                return true;
            }
        }
    }
    return false;
}

export function UserAccessContextOriginFromJSON(json: any): UserAccessContextOrigin {
    return UserAccessContextOriginFromJSONTyped(json, false);
}

export function UserAccessContextOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserAccessContextOrigin {
    return json as UserAccessContextOrigin;
}

export function UserAccessContextOriginToJSON(value?: UserAccessContextOrigin | null): any {
    return value as any;
}

export function UserAccessContextOriginToJSONTyped(value: any, ignoreDiscriminator: boolean): UserAccessContextOrigin {
    return value as UserAccessContextOrigin;
}

